import { createAppAsyncThunk } from "core/src/store/store.types";

export type NavigateRequest = {
	pathname: string;
}

type NavigateResponse = {
	pathname: string;
}

export const navigate = createAppAsyncThunk<NavigateResponse, NavigateRequest>(
	"navigation/navigate",
	async ({ pathname }: NavigateRequest, { extra }) => {
		extra.navigationService.navigate(pathname);
		return { pathname };
	}
);
